import { JSX, useState, useRef, useEffect } from 'react';
import WindowBar from '../common/windowBar/windowBar';
import TodoIcon from '../assets/images/icons/calendar.png';
import CalendarTimeView from './calendarTimeView';
import './calendarPage.css';
import Events from './Events';
import CalendarPicker from './calendar-picker/calendarPicker';
import { CalendarId } from '../services/calendarService';
import viewIcon from '../assets/images/text-editor/view.png'
import calendarIcon from '../assets/images/icons/calendar_outline.png'
import IconButton from '../common/iconButton';
import CalendarView from './calendarView/calendarView';

const CalendarPage = ({ setClosePage }: { setClosePage: () => void }): JSX.Element => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [selectedCalendar, setSelectedCalendar] = useState<CalendarId[]>(['primary', 'taiwan holiday', 'us holiday', 'work', 'HYTE']);
    const [startDate, setStartDate] = useState<Date>(() => {
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
    });
    const [endDate, setEndDate] = useState<Date>(new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0));
    
    const viewModeKey = 'calendar-view-mode';
    const getViewMode = (): CalendarMode=> {
        try {
            const mode = localStorage.getItem(viewModeKey) as CalendarMode;
            if (mode === 'list-view' || mode === 'calendar-view') {
                return mode; // TypeScript knows this is a CalendarMode now
            }
            // If we get here, mode was not a valid CalendarMode
            console.log('Retrieved mode was not valid, using default');
        } catch (error) {
            console.error('Failed to save calendar view mode:', error);
        }
        return 'list-view';
    }

    const [calendarMode, setCalendarMode] = useState<CalendarMode>(getViewMode() || null); 
    const handleCalendarSelect = (calendarId: CalendarId[]) => {
        setSelectedCalendar(calendarId);
    }

    const handleViewChange = (mode: CalendarMode) => {
        setCalendarMode(mode);
        try {
            localStorage.setItem(viewModeKey, mode);
            console.log(`save view mode ${mode}`);
        } catch (error) {
            console.error('Failed to save calendar view mode:', error);
        }
    }

    useEffect(() => {
        setCalendarMode(getViewMode());
    })

    return (
        <div className='addTodo-outter outter-container' ref={containerRef}>
            <div className='pixel-container-back'/>
            <div className='pixel-container-top addTodo-container'>
                <div className='addPage-inner'>
                    <WindowBar IconSrc={TodoIcon} title={'Calendar'} onClick={setClosePage}>
                        <IconButton src={viewIcon} alt="add icon" clickFunction={()=> handleViewChange('list-view')}/>
                        <IconButton src={calendarIcon} alt="add icon" clickFunction={()=> handleViewChange('calendar-view')}/>
                    </WindowBar>
                    <div className='main-pixel-container calendar-page-content'>
                        <CalendarPicker selectedCalendar={selectedCalendar} onCalendarSelect={handleCalendarSelect}/>
                        <div className="divider-horizontal"/>
                        {calendarMode === 'list-view' ? (
                            <>
                            <CalendarTimeView startDate={startDate} endDate={endDate}/>
                            <div className="divider-horizontal"/>
                            <Events startDate={startDate} endDate={endDate} selectedCalendar={selectedCalendar} setEndDate={setEndDate}/>
                            </>) : (
                        <CalendarView/>
                    )}
                    </div>
                </div>
            </div>
        </div>
    );
};

type CalendarMode = 'list-view' | 'calendar-view';

export default CalendarPage;
